import React from 'react';
import { Link } from 'react-router-dom';

import LOGO from '_app/assets/images/logo.png';

export const Logo = ({ publicId, onNavigateHome = () => {} }) => {
  if (publicId) {
    return (
      <Link to={`/${publicId}/listing/new/`}>
        <img src={LOGO} width="100" height="50" alt="logo" onClick={onNavigateHome} />
      </Link>
    );
  } else {
    return (
      <a href="https://www.houstonproperties.com/" rel="noreferrer">
        <img src={LOGO} width="100" height="50" alt="logo" />
      </a>
    );
  }
};
